define("shared/components/shared/credentials/page-list", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component"], function (_exports, _component, _templateFactory, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <ul class="u--listUnstyle">
    {{!-- Options list --}}
    {{#each this.alternatePages as |page|}}
      <Shared::Credentials::PageItem
        @socialProfile={{@socialProfile}}
        @page={{page}}
        @selectPage={{action @selectPage}}
        @isActivePage={{eq page.id @state.activePage.id}}
      />
    {{/each}}
    {{!-- None of these --}}
    {{#if this.alternatePages.length}}
      <li
        class="o--card tAC--statusCard {{if (eq @state.activePage.id 0) "tAC--statusCard--active" ""}}"
        {{on "click" (action @selectPageNotFound)}}
      >
        <div class="o--cardBody u--p__lr__sm">
          <p class="u--text--bold u--m__tb__sm u--p__r__xs">
            {{t "credentials.pageList.none"}}
            {{!-- Icon --}}
            {{#if (eq @state.activePage.id 0)}}
              {{svg-jar "verified-solid" class="o--icon--md o--icon--success u--float--right"}}
            {{else}}
              {{svg-jar "circle" class="o--icon--md o--icon--light u--float--right"}}
            {{/if}}
          </p>
          <div class="tAC--statusCard__info">
            <hr class="u--m__tb__sm">
            <p class="u--m__b__0">{{t "credentials.pageList.none_description"}}</p>
          </div>
        </div>
      </li>
    {{else}}
      <li
        class="o--card tAC--statusCard tAC--statusCard--active"
        {{did-insert (action @selectPageNotFound)}}
      >
        <div class="o--cardBody u--p__lr">
          <p class="u--text--bold u--m__tb__xs">
            {{t "credentials.pageList.none_title"}}
            {{!-- Icon --}}
            {{svg-jar "nav-down" class="o--icon u--float--right"}}
          </p>
          <div class="tAC--statusCard__info">
            <hr class="u--m__tb__sm">
            <p class="u--m__b__0">{{t "credentials.pageList.none_description"}}</p>
          </div>
        </div>
      </li>
    {{/if}}
  </ul>
  
  */
  {
    "id": "y7Giv0Rc",
    "block": "[[[10,\"ul\"],[14,0,\"u--listUnstyle\"],[12],[1,\"\\n\"],[42,[28,[37,1],[[28,[37,1],[[30,0,[\"alternatePages\"]]],null]],null],null,[[[1,\"    \"],[8,[39,2],null,[[\"@socialProfile\",\"@page\",\"@selectPage\",\"@isActivePage\"],[[30,2],[30,1],[28,[37,3],[[30,0],[30,3]],null],[28,[37,4],[[30,1,[\"id\"]],[30,4,[\"activePage\",\"id\"]]],null]]],null],[1,\"\\n\"]],[1]],null],[41,[30,0,[\"alternatePages\",\"length\"]],[[[1,\"    \"],[11,\"li\"],[16,0,[29,[\"o--card tAC--statusCard \",[52,[28,[37,4],[[30,4,[\"activePage\",\"id\"]],0],null],\"tAC--statusCard--active\",\"\"]]]],[4,[38,6],[\"click\",[28,[37,3],[[30,0],[30,5]],null]],null],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--cardBody u--p__lr__sm\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--text--bold u--m__tb__sm u--p__r__xs\"],[12],[1,\"\\n          \"],[1,[28,[35,7],[\"credentials.pageList.none\"],null]],[1,\"\\n\"],[41,[28,[37,4],[[30,4,[\"activePage\",\"id\"]],0],null],[[[1,\"            \"],[1,[28,[35,8],[\"verified-solid\"],[[\"class\"],[\"o--icon--md o--icon--success u--float--right\"]]]],[1,\"\\n\"]],[]],[[[1,\"            \"],[1,[28,[35,8],[\"circle\"],[[\"class\"],[\"o--icon--md o--icon--light u--float--right\"]]]],[1,\"\\n\"]],[]]],[1,\"        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"tAC--statusCard__info\"],[12],[1,\"\\n          \"],[10,\"hr\"],[14,0,\"u--m__tb__sm\"],[12],[13],[1,\"\\n          \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,[28,[35,7],[\"credentials.pageList.none_description\"],null]],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[11,\"li\"],[24,0,\"o--card tAC--statusCard tAC--statusCard--active\"],[4,[38,9],[[28,[37,3],[[30,0],[30,5]],null]],null],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--cardBody u--p__lr\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--text--bold u--m__tb__xs\"],[12],[1,\"\\n          \"],[1,[28,[35,7],[\"credentials.pageList.none_title\"],null]],[1,\"\\n\"],[1,\"          \"],[1,[28,[35,8],[\"nav-down\"],[[\"class\"],[\"o--icon u--float--right\"]]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"tAC--statusCard__info\"],[12],[1,\"\\n          \"],[10,\"hr\"],[14,0,\"u--m__tb__sm\"],[12],[13],[1,\"\\n          \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,[28,[35,7],[\"credentials.pageList.none_description\"],null]],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[13],[1,\"\\n\"]],[\"page\",\"@socialProfile\",\"@selectPage\",\"@state\",\"@selectPageNotFound\"],false,[\"each\",\"-track-array\",\"shared/credentials/page-item\",\"action\",\"eq\",\"if\",\"on\",\"t\",\"svg-jar\",\"did-insert\"]]",
    "moduleName": "shared/components/shared/credentials/page-list.hbs",
    "isStrictMode": false
  });

  class PageList extends _component2.default {
    get alternatePages() {
      var _this$args$pages;

      return (_this$args$pages = this.args.pages) === null || _this$args$pages === void 0 ? void 0 : _this$args$pages.filter(page => {
        var _this$args$connectedP;

        return page.id !== ((_this$args$connectedP = this.args.connectedPage) === null || _this$args$connectedP === void 0 ? void 0 : _this$args$connectedP.id);
      });
    }

  }

  _exports.default = PageList;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PageList);
});